import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
import { PRODUCT_NAME } from '../data/offer';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5500;
const GAP_MS = 12000;

/**
 * Notificación “alguien acaba de comprar”, abajo a la izquierda.
 * Solo se muestra si data/recentPurchases.ts tiene pedidos reales.
 */
export function PurchaseNotifications() {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const hasData = recentPurchases.length > 0;
  useEffect(() => {
    if (dismissed || !hasData) return;
    let timeout: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timeout = setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = setTimeout(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        show();
      }, GAP_MS);
    };
    timeout = setTimeout(show, FIRST_DELAY);
    return () => clearTimeout(timeout);
  }, [dismissed, hasData]);
  if (dismissed || !hasData) return null;
  const purchase = recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" data-id="element-222" data-mp="ewqcsc0c2js0">
      <AnimatePresence data-id="element-223" data-mp="17kchjnlarugg">
        {visible && <motion.div key={index} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[320px] max-w-full items-start gap-3 rounded-xl border border-sand-dark bg-white p-3.5 shadow-card" data-id="element-224" data-mp="17km9vhttedpb">
            <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-sage/15" data-id="element-225" data-mp="3ks40x00nm5ox">
              <CheckIcon className="h-4 w-4 text-sage" aria-hidden="true" data-id="element-226" data-mp="3pp48jfd5jgi5" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-227" data-mp="3as3c4yk0mxdc">
              <p className="text-[13px] leading-snug text-ink" data-id="element-228" data-mp="3frfzrlipo8gz">
                <span className="font-bold" data-id="element-229" data-mp="3fpv8q5vlv7nv">{purchase.name}</span> in{' '}
                {purchase.city}, {purchase.state} just got {PRODUCT_NAME}
              </p>
              <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-ink-muted" data-id="element-230" data-mp="36s2z9ickeu8e">
                {purchase.minutesAgo} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="-mr-1 -mt-1 flex h-7 w-7 flex-none items-center justify-center rounded-full text-ink-muted transition-colors duration-150 hover:bg-cream hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-terra" data-id="element-231" data-mp="2x0ovgydkz89g">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-232" data-mp="1zgozfjp30frb" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}